module.exports = __webpack_public_path__ + "img/phone.514ca2ae.svg";